const styles = () => ({
  actionMenu: {
    position: 'unset!important',
  },
});

export default styles;
